module.exports = __webpack_public_path__ + "img/img12.0c04b769.png";